import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';

/**
 * Modal de validación (Aprobar / Observar) para:
 *  - Jefe Inmediato (estado 0 → 1 aprobar | 0 → 3 observar)
 *  - Talento Humano / perfiles 8 y 26 (estado 1 → 2 aprobar | → 3 observar)
 *    En tipo 2 (Invitación Directa): estado 0 → 2 aprobar | → 3 observar
 *
 * Props:
 *  - isOpen, onClose, onModalClosed
 *  - registro: el registro a validar
 *  - onAprobar(comentario): callback
 *  - onObservar(comentario): callback
 *  - titulo: string del encabezado
 */
const ModalValidacionReclutamiento = ({
    isOpen,
    onClose,
    onModalClosed,
    registro,
    onAprobar,
    onObservar,
    titulo = 'VALIDAR SOLICITUD',
}) => {
    const [comentario, setComentario] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (isOpen) setComentario('');
    }, [isOpen]);

    const handleAprobar = async () => {
        setSaving(true);
        try {
            await onAprobar(comentario.trim() || null);
            onClose(true);
        } catch (error) {
            console.error('Error al aprobar:', error);
            alert(error?.response?.data?.message || 'Error al aprobar la solicitud.');
        } finally {
            setSaving(false);
        }
    };

    const handleObservar = async () => {
        if (!comentario.trim()) {
            alert('Debe ingresar un comentario para observar la solicitud.');
            return;
        }
        setSaving(true);
        try {
            await onObservar(comentario.trim());
            onClose(true);
        } catch (error) {
            console.error('Error al observar:', error);
            alert(error?.response?.data?.message || 'Error al observar la solicitud.');
        } finally {
            setSaving(false);
        }
    };

    if (!registro) return null;

    return (
        <Modal isOpen={isOpen} onClosed={onModalClosed} className="custom-modal" backdrop="static" size="md">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{titulo}</h1>
                    <Button className="close-btn" onClick={() => onClose()}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form onSubmit={(e) => e.preventDefault()}>

                        {/* Info de la solicitud */}
                        <div style={{
                            background: '#f8faff',
                            border: '1px solid #c3d8f5',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            marginBottom: '16px',
                        }}>
                            <p style={{ margin: 0, fontSize: '11px', color: '#555', marginBottom: '6px' }}>
                                <strong>Solicitante:</strong> {registro.nombre_solicitante || registro.solicitante_id}
                            </p>
                            <p style={{ margin: 0, fontSize: '11px', color: '#555', marginBottom: '6px' }}>
                                <strong>Tipo:</strong>{' '}
                                {registro.tipo_solicitud === 1 ? 'Proceso de Reclutamiento' : 'Invitacion Directa'}
                            </p>
                            <p style={{ margin: 0, fontSize: '11px', color: '#333' }}>
                                <strong>Solicitud:</strong> {registro.solicitud}
                            </p>
                            {registro.tipo_solicitud === 2 && registro.nombre && (
                                <p style={{ margin: '6px 0 0', fontSize: '11px', color: '#333' }}>
                                    <strong>Candidatos:</strong> {registro.apellido} {registro.nombre} — {registro.dni}
                                </p>
                            )}
                        </div>

                        <FormGroup>
                            <Label>
                                Comentario:{' '}
                                <span style={{ fontSize: '10px', color: '#888' }}>
                                    (requerido para Observar, opcional para Aprobar)
                                </span>
                            </Label>
                            <Input
                                type="textarea"
                                value={comentario}
                                onChange={(e) => setComentario(e.target.value)}
                                placeholder="Ingrese un comentario..."
                                rows={3}
                                style={{ maxHeight: '90px', borderRadius: '8px' }}
                            />
                        </FormGroup>

                        <div className="button-container" style={{ gap: '10px' }}>
                            <Button
                                style={{
                                    background: 'linear-gradient(135deg, #dc3545, #c82333)',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '8px 18px',
                                    fontSize: '12px',
                                    color: 'white',
                                    fontWeight: 600,
                                }}
                                disabled={saving}
                                onClick={() => {
                                    if (window.confirm('¿Está seguro de OBSERVAR esta solicitud?')) {
                                        handleObservar();
                                    }
                                }}
                            >
                                OBSERVAR
                            </Button>
                            <Button
                                style={{
                                    background: 'linear-gradient(135deg, #28a745, #1e7e34)',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '8px 18px',
                                    fontSize: '12px',
                                    color: 'white',
                                    fontWeight: 600,
                                }}
                                disabled={saving}
                                onClick={() => {
                                    if (window.confirm('¿Está seguro de APROBAR esta solicitud?')) {
                                        handleAprobar();
                                    }
                                }}
                            >
                                APROBAR
                            </Button>
                        </div>

                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalValidacionReclutamiento;
